/* Packages */
import React from 'react';
import { render } from 'react-dom';

const productPreviewNodes = Array.from(document.querySelectorAll('[data-product-preview]'));
if (productPreviewNodes.length) {
    import(/* webpackChunkName: "ProductPreview" */ './components/ProductPreview').then(({ default: ProductPreview }) => {
        productPreviewNodes.forEach((node) => render(<ProductPreview {...(JSON.parse(node.dataset.productPreview || '{}'))}/>, node));
    });
}

const productSearchPreviewNodes = Array.from(document.querySelectorAll('[data-product-search-preview]'));
if (productSearchPreviewNodes.length) {
    import(/* webpackChunkName: "ProductSearchPreview" */ './components/ProductSearchPreview').then(({ default: ProductSearchPreview }) => {
        productSearchPreviewNodes.forEach((node) => render(<ProductSearchPreview {...(JSON.parse(node.dataset.productSearchPreview || '{}'))}/>, node));
    });
}
